<!-- src/views/Home.vue -->
<template>
    <div class="home">
        <h1>Hello World!</h1>
    </div>
</template>

<script>
export default {
    name: "Home",
    data() {
        return {};
    },
    created() {},

    methods: {},
};
</script>

<style lang="scss" scoped>
.home {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
